import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=0cb6e109&scoped=true"
import script from "./medical.vue?vue&type=script&lang=ts"
export * from "./medical.vue?vue&type=script&lang=ts"
import style0 from "./medical.vue?vue&type=style&index=0&id=0cb6e109&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6e109",
  null
  
)

export default component.exports